import React, { Component } from "react";
import { MyContext } from "../../../../../context";
import { Query } from "react-apollo";
import {
    Spinner,
    Text,
    TextField,
    Dialog,
    DialogType,
    DialogFooter,
    PrimaryButton,
    DefaultButton,
    Dropdown,
    Checkbox,
    Stack,
    Label,
    CommandBarButton,
    FontSizes,
    SpinnerSize,
} from "office-ui-fabric-react";
import AlertBar from "../../../../CustomComponents/AlertBar";
import UserPicker from "../../../../ReportView/ReportConfiguration/UserPicker";
import IncidentHistory from "./IncidentHistory";
import {
    getIncidentStatusTypeEnum,
    getAllFoldersShrinked,
    getConversationCases,
    changeIncidentStatus,
    changeIncidentRiskRating,
    forwardTo,
    moveTo,
    getIncidentThread,
    getGroupListForLoggedUser,
    getGroups,
} from "../../../../ConversationSafe/ConversationSafeQuery";

export default class Incident extends Component {
    static contextType = MyContext;
    constructor(props) {
        super(props);
        this.state = {
            isDialogHidden: true,
            isHistoryView: false,
            type: "",
            status: this.props.status,
            riskRating: this.props.riskRating,
            caseStatus: this.props.caseStatus,
            forwardUsers: null,
            moveToCaseId: null,
            comments: "",
            isReviewer: false,
            mutationLoading: false,
            allReviewrsAndAssignees: [],
        };
    }

    async componentDidMount() {
        await this.checkReviewerStatus();
        await this.getAvailableForwardUsers();
    }

    checkReviewerStatus = async () => {
        const userId = this.props.userRules.userId;

        //the user can chenge the status, the risk rating, and forward the incident 
        //if he is in reviewers or forwardTo list
        const isDirectReviewer = this.props.reviewers.includes(userId) || this.props.forwardTo?.includes(userId);

        if (isDirectReviewer) {
            this.setState({ isReviewer: true });
        } else {
            try {
                const result = await this.props.client.query({
                    query: getGroupListForLoggedUser,
                    variables: {},
                });
                if (result.data && result.data.getGroupListForLoggedUser) {
                    const userGroups = result.data.getGroupListForLoggedUser;
                    const isGroupReviewer = userGroups.some((groupId) => this.props.reviewers.includes(groupId));
                    this.setState({ isReviewer: isGroupReviewer });
                }
            } catch (error) {
                console.error("Error fetching user groups:", error);
                this.setState({ isReviewer: false });
            }
        }
    };

    getAvailableForwardUsers = async () => {
        const allIDs = [...this.props.reviewers, ...this.props.observers];
        let uniqueIDs = [...new Set(allIDs)];

        try {
            const result = await this.props.client.query({
                query: getGroups,
                variables: {},
            });
            if (result?.data?.getGroups) {
                const assignedUserFromGroups = result.data.getGroups
                    .filter((group) => uniqueIDs.includes(group.adGroupId))
                    .map((group) => {
                        uniqueIDs = uniqueIDs.filter((id) => id !== group.adGroupId);
                        return group.users.split(",");
                    });
                const allUsers = assignedUserFromGroups.flat();
                uniqueIDs = [...new Set([...uniqueIDs, ...allUsers])];

                this.setState({ allReviewrsAndAssignees: uniqueIDs });
            }
        } catch (error) {
            console.error("Error fetching all groups:", error);
            this.setState({ allReviewrsAndAssignees: [] });
        }
    };

    getModalTitle = (type) => {
        switch (type) {
            case "status":
                return this.context.getTranslation("detailContainer", "changeStatus");
            case "riskRating":
                return this.context.getTranslation("detailContainer", "changeRiskRating");
            case "forwardTo":
                return this.context.getTranslation("detailContainer", "forwardTo");
            case "moveTo":
                return this.context.getTranslation("detailContainer", "moveTo");
            default:
                return "";
        }
    };

    renderModalContent = (type) => {
        switch (type) {
            case "status":
                return (
                    <>
                        <Query query={getIncidentStatusTypeEnum}>
                            {({ loading, error, data }) => {
                                if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />;
                                if (error) {
                                    console.log(error);
                                    return <AlertBar message={"Error!"} alertType={"error"} />;
                                }
                                if (data.getIncidentStatusTypeEnum == null || data.getIncidentStatusTypeEnum.length === 0)
                                    return <AlertBar message={this.context.getTranslation("compliance", "noData")} alertType={"warning"} />;
                                const options = data.getIncidentStatusTypeEnum.map((status) => ({
                                    key: status.name,
                                    text: this.context.getTranslation("compliance", status.name.toLowerCase()),
                                }));
                                return (
                                    <Dropdown
                                        id={"contentStatus"}
                                        selectedKey={this.state.status}
                                        onChange={(_, value) => this.setState({ status: value.key })}
                                        label={this.context.getTranslation("conversationSafe", "status")}
                                        options={options}
                                    />
                                );
                            }}
                        </Query>

                        <TextField
                            required
                            label={this.context.getTranslation("settings", "ticketComment")}
                            multiline
                            rows={4}
                            value={this.state.comments}
                            onChange={(_, newValue) => {
                                this.setState({ comments: newValue });
                            }}
                        />
                    </>
                );
            case "riskRating":
                return (
                    <>
                        <Stack style={{ marginTop: "10px", gap: "20px" }} horizontal>
                            <Checkbox
                                label={this.context.getTranslation("compliance", "riskRatingInformation")}
                                id={"Info"}
                                checked={this.state.riskRating === "Info"}
                                onChange={(e, _) => this.setState({ riskRating: e.target.id })}
                            />
                            <Checkbox
                                label={this.context.getTranslation("compliance", "riskRatingAdherence")}
                                id={"Adherence"}
                                checked={this.state.riskRating === "Adherence"}
                                onChange={(e, _) => this.setState({ riskRating: e.target.id })}
                            />
                            <Checkbox
                                label={this.context.getTranslation("compliance", "riskRatingWarning")}
                                id={"Warn"}
                                checked={this.state.riskRating === "Warn"}
                                onChange={(e, _) => this.setState({ riskRating: e.target.id })}
                            />
                        </Stack>

                        <TextField
                            label={this.context.getTranslation("settings", "ticketComment")}
                            multiline
                            rows={4}
                            value={this.state.comments}
                            onChange={(_, newValue) => {
                                this.setState({ comments: newValue });
                            }}
                        />
                    </>
                );
            case "forwardTo":
                return (
                    <div>
                        <Label>{this.context.getTranslation("detailContainer", "selectUser")}</Label>
                        <UserPicker
                            user={this.state.forwardUsers}
                            itemLimit={1}
                            placeholder={this.context.getTranslation("detailContainer", "selectUserPlaceholder")}
                            availableUsers={this.state.allReviewrsAndAssignees.filter(id => id !== this.props.userRules?.userId)}
                            fc={(selectedUsers) => {
                                this.setState({ forwardUsers: selectedUsers });
                            }}
                        />
                    </div>
                );
            case "moveTo":
                return (
                    <>
                        <Query query={getAllFoldersShrinked} variables={{ input: this.props.authorization, filter: "CaseManagement" }}>
                            {({ loading, error, data }) => {
                                if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />;
                                if (error) {
                                    console.log(error);
                                    return <AlertBar message={"Error!"} alertType={"error"} />;
                                }

                                const availableCases = data.getConversationSafeFolders
                                    .filter((caseItem) => caseItem.id !== this.props.caseId)
                                    .map((caseItem) => ({ key: caseItem.id, text: caseItem.name }));

                                return (
                                    <Dropdown
                                        style={{ width: "300px" }}
                                        required
                                        placeholder={this.context.getTranslation("detailContainer", "moveToPlaceholder")}
                                        label={this.context.getTranslation("detailContainer", "case")}
                                        onChange={(_, value) => this.setState({ moveToCaseId: value.key })}
                                        width={400}
                                        multiSelect={false}
                                        selectedKey={this.state.moveToCaseId}
                                        options={availableCases}
                                    />
                                );
                            }}
                        </Query>
                        <TextField
                            label={this.context.getTranslation("settings", "ticketComment")}
                            multiline
                            rows={4}
                            value={this.state.comments}
                            onChange={(_, newValue) => {
                                this.setState({ comments: newValue });
                            }}
                        />
                    </>
                );

            default:
                return null;
        }
    };

    checkSave = (type) => {
        switch (type) {
            case "status":
                return this.state.status !== this.props.status && this.state.comments.length > 0;
            case "riskRating":
                return this.state.riskRating !== this.props.riskRating;
            case "forwardTo":
                return this.state.forwardUsers && this.state.forwardUsers.length > 0;
            case "moveTo":
                return this.state.moveToCaseId !== null;
            default:
                return false;
        }
    };

    save = () => {
        this.setState({ mutationLoading: true });
        this.props.isProcessing(true);

        let mutation;
        let variables;

        switch (this.state.type) {
            case "status":
                mutation = changeIncidentStatus;
                variables = {
                    caseId: this.props.caseId,
                    conversationId: this.props.conversationId,
                    newStatus: this.state.status,
                    comment: this.state.comments,
                };
                break;
            case "riskRating":
                mutation = changeIncidentRiskRating;
                variables = {
                    caseId: this.props.caseId,
                    conversationId: this.props.conversationId,
                    newRiskRating: this.state.riskRating,
                };
                break;
            case "forwardTo":
                mutation = forwardTo;
                variables = {
                    caseId: this.props.caseId,
                    conversationId: this.props.conversationId,
                    userSelected: this.state.forwardUsers[0].userId,
                };
                break;
            case "moveTo":
                mutation = moveTo;
                variables = {
                    caseIdFrom: this.props.caseId,
                    conversationId: this.props.conversationId,
                    caseIdTo: this.state.moveToCaseId,
                    comment: this.state.comments,
                    input: this.props.authorization,
                };
                break;
        }

        this.props.client
            .mutate({
                mutation: mutation,
                variables: variables,
                awaitRefetchQueries: true,
                refetchQueries: [
                    {
                        query: getAllFoldersShrinked,
                        variables: { input: this.props.authorization, filter: "CaseManagement" },
                    },
                    {
                        query: getConversationCases,
                        variables: { conversationId: this.props.conversationId },
                    },
                    {
                        query: getIncidentThread,
                        variables: { id: this.props.incidentThreadId, input: this.props.authorization },
                    },
                ],
            })
            .then((result) => {
                this.props.isProcessing(false);
                this.setState({ isDialogHidden: true, mutationLoading: false });
                this.props.onDataUpdated();
                this.props.refreshFolderList(true)
            })
            .catch((error) => {
                console.error(error);
                this.props.isProcessing(false);
                this.setState({ isDialogHidden: true, mutationLoading: false });
            });
    };

    getRiskRatingLabel = (rating) => {
        let label;
        switch (rating) {
            case "Info": label = this.context.getTranslation("compliance", "riskRatingInformation"); break;
            case "Adherence": label = this.context.getTranslation("compliance", "riskRatingAdherence"); break;
            case "Warn": label = this.context.getTranslation("compliance", "riskRatingWarning"); break;
            default: label = rating;
        }
        return label;
    }


    render() {
        return (
            <MyContext.Consumer>
                {(context) => (
                    <>
                        <div style={{ padding: "20px", display: "flex", gap: "20px", justifyContent: "space-between", alignItems: "flex-start" }}>
                            {!this.state.isHistoryView ? (
                                <>
                                    <Stack horizontal={true} tokens={{ childrenGap: 20 }}>
                                        {/* STATUS */}
                                        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                                            <Text style={{ fontWeight: "bold" }}>
                                                {this.context.getTranslation("conversationSafe", "status")}: {this.context.getTranslation("compliance", this.props.status.toLowerCase())}
                                            </Text>
                                            {this.state.isReviewer && this.state.caseStatus != "CLOSED" && (
                                                <DefaultButton
                                                    text={this.context.getTranslation("detailContainer", "changeStatus")}
                                                    onClick={(e) => {
                                                        this.setState({ isDialogHidden: false, type: "status" });
                                                    }}
                                                />
                                            )}
                                        </div>
                                        {/* RISK RATING */}
                                        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                                            <Text style={{ fontWeight: "bold" }}>
                                                {this.context.getTranslation("compliance", "detailPolicyRiskRating")}: {this.getRiskRatingLabel(this.props.riskRating)}
                                            </Text>
                                            {this.state.isReviewer && this.state.caseStatus != "CLOSED" && (
                                                <DefaultButton
                                                    text={this.context.getTranslation("detailContainer", "changeRiskRating")}
                                                    onClick={(e) => {
                                                        this.setState({ isDialogHidden: false, type: "riskRating" });
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Stack>
                                    <CommandBarButton
                                        text={this.context.getTranslation("dashboard", "widgetMenuActions")}
                                        style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon, backgroundColor: "transparent" }}
                                        menuProps={{
                                            items: [
                                                ...((this.state.isReviewer && this.state.caseStatus != "CLOSED")
                                                    ? [
                                                        {
                                                            key: "forwardTo",
                                                            text: this.context.getTranslation("detailContainer", "forwardTo"),
                                                            onClick: () => this.setState({ isDialogHidden: false, type: "forwardTo" }),
                                                        },
                                                    ]
                                                    : []),
                                                ...((this.state.allReviewrsAndAssignees.includes(this.props.userRules.userId) && this.state.caseStatus != "CLOSED")
                                                    ? [
                                                        {
                                                            key: "moveTo",
                                                            text: this.context.getTranslation("detailContainer", "moveTo"),
                                                            onClick: () => this.setState({ isDialogHidden: false, type: "moveTo" }),
                                                        },
                                                    ]
                                                    : []),
                                                {
                                                    key: "history",
                                                    text: this.context.getTranslation("detailContainer", "history"),
                                                    onClick: () => this.setState({ isHistoryView: true }),
                                                },
                                            ],
                                        }}
                                    />
                                </>
                            ) : (
                                // HISTORY VIEW
                                <IncidentHistory
                                    incidentThreadId={this.props.incidentThreadId}
                                    handleBack={() => this.setState({ isHistoryView: false })}
                                    auth={this.props.authorization}
                                    height={this.props.height}
                                />
                            )}
                        </div>
                        {/* MODAL */}
                        <Dialog
                            hidden={this.state.isDialogHidden}
                            onDismiss={() => this.setState({ isDialogHidden: true })}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: this.getModalTitle(this.state.type),
                                closeButtonAriaLabel: this.context.getTranslation("common", "close"),
                            }}
                            minWidth="350px"
                            maxWidth="90vw"
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "20px" }}>
                                {this.renderModalContent(this.state.type)}
                            </div>
                            <DialogFooter>
                                <DefaultButton
                                    onClick={() => this.setState({ isDialogHidden: true })}
                                    text={context.getTranslation("common", "close")}
                                    disabled={this.state.mutationLoading}
                                />
                                <PrimaryButton
                                    onClick={() => this.save()}
                                    text={
                                        this.state.mutationLoading ? (
                                            <Spinner style={{ paddingLeft: "5px", position: "relative", top: "2px" }} size={SpinnerSize.xSmall} />
                                        ) : (
                                            context.getTranslation("common", "save")
                                        )
                                    }
                                    disabled={!this.checkSave(this.state.type) || this.state.mutationLoading}
                                />
                            </DialogFooter>
                        </Dialog>
                    </>
                )}
            </MyContext.Consumer>
        );
    }
}
